/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Benefit_Protection_DescInputs */

const en_home_benefit_protection_desc = /** @type {(inputs: Home_Benefit_Protection_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprehensive medical, trip cancellation, and disruption coverage tailored for Canadian travellers.`)
};

const fr_home_benefit_protection_desc = /** @type {(inputs: Home_Benefit_Protection_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couverture médicale complète, annulation de voyage et perturbations adaptée aux voyageurs canadiens.`)
};

/**
* | output |
* | --- |
* | "Comprehensive medical, trip cancellation, and disruption coverage tailored for Canadian travellers." |
*
* @param {Home_Benefit_Protection_DescInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_benefit_protection_desc = /** @type {((inputs?: Home_Benefit_Protection_DescInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Benefit_Protection_DescInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_benefit_protection_desc(inputs)
	return fr_home_benefit_protection_desc(inputs)
});